import { render } from "./StatusCompleted.svg?vue&type=template&id=ad10e454"
const script = {}
script.render = render

export default script